import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import resizable from "hocs/resizable"
import tooltipContainer from "hocs/tooltip-container"
import LineTargetChart from "./components/chart"
import { getApproximateDataSet, getLine, getXAxis, getYAxis, getHighlighter, getScaleX, getScaleY, getHeight, getWidth } from "./helper"

class LineTargetWrapper extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    dots: PropTypes.array,
    resizableRef: PropTypes.func.isRequired,
    line: PropTypes.object,
    xAxis: PropTypes.object,
    yAxis: PropTypes.object,
    highlighter: PropTypes.object,
    height: PropTypes.number,
    bestPoint: PropTypes.object,
    originalPoint: PropTypes.object,
    tooltipTitle: PropTypes.string,
    scaleY: PropTypes.func.isRequired,
    scaleX: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    setSelectedData: PropTypes.func,
    TooltipContent: PropTypes.any.isRequired,
    disabledClick: PropTypes.bool,
    focused: PropTypes.shape({
      color: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  }

  render() {
    const {
      data,
      resizableRef,
      line,
      xAxis,
      yAxis,
      highlighter,
      bestPoint,
      originalPoint,
      scaleY,
      scaleX,
      subscribe,
      setSelectedData,
      unsubscribe,
      height,
      width,
      dots,
      tooltipTitle,
      TooltipContent,
      disabledClick,
      focused,
    } = this.props

    return <LineTargetChart
      resizableRef={resizableRef}
      data={data}
      line={line}
      xAxis={xAxis}
      focused={focused}
      yAxis={yAxis}
      highlighter={highlighter}
      bestPoint={bestPoint}
      originalPoint={originalPoint}
      scaleY={scaleY}
      scaleX={scaleX}
      dots={dots}
      subscribe={subscribe}
      setSelectedData={setSelectedData}
      unsubscribe={unsubscribe}
      height={height}
      tooltipTitle={tooltipTitle}
      width={width}
      TooltipContent={TooltipContent}
      disabledClick={disabledClick}
    />
  }
}

const mapStateToProps = (state, props) => ({
  data: getApproximateDataSet(props),
  xAxis: getXAxis(props),
  yAxis: getYAxis(props),
  line: getLine(props),
  scaleX: getScaleX(props),
  scaleY: getScaleY(props),
  height: getHeight(props),
  width: getWidth(props),
  highlighter: getHighlighter(props),
})

export default tooltipContainer(resizable(connect(mapStateToProps)(LineTargetWrapper)))
